import { render, staticRenderFns } from "./IntroductionText.vue?vue&type=template&id=01b8f948&"
import script from "./IntroductionText.vue?vue&type=script&lang=ts&"
export * from "./IntroductionText.vue?vue&type=script&lang=ts&"
import style0 from "./IntroductionText.vue?vue&type=style&index=0&id=01b8f948&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports